import bgImage from '../images/vedio_holder.png';
import { useState } from 'react';


//video content with popup
const VideoContent = ({ videoContent }) => {
  const [modal, setModal] = useState(false);
  const [videoLoading, setVideoLoading] = useState(true);

  const openModal = () => {
    setModal(!modal);
  };

  const closeVideo = () => {
    setModal(false);
  };
  const spinner = () => {
    setVideoLoading(!videoLoading);
  };

  return (
    <>
      <div className="row">
        <div className="col-12">
          <div className="player bg-parallax bg-section" style={{ backgroundImage: `url(${videoContent.imageUrl ? videoContent.imageUrl : bgImage})` }}>
            <a onClick={openModal} className="btn-video popup-video" >
              <svg xmlns="http://www.w3.org/2000/svg" width="22" height="29" viewBox="0 0 22 29">
                <path id="Polygon_4" data-name="Polygon 3" d="M12,3.8A3,3,0,0,1,17,3.8l8.93,13.549A3,3,0,0,1,23.43,22H5.57a3,3,0,0,1-2.5-4.651Z" transform="translate(24) rotate(90)"></path>
              </svg></a>
          </div>



        </div>
      </div>

      {modal ? (
        <div className="modal__bg">
          <div className="overlay" >
            <div className="modal__align">
              <div className="modal__content" >

                <div className="modal__video-align">
                  <div className="modal__close" arial-label="Close modal" onClick={closeVideo}>X</div>
                  {videoLoading ? (
                    <div className="modal__spinner"></div>
                  ) : null}
                  <iframe className="modal__video-style" onLoad={spinner} loading="lazy" width="800" height="500"
                    src={videoContent.video_link} title="YouTube video player" frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen
                  ></iframe>
                </div>
              </div>
            </div>
          </div>

        </div>
      ) : null}


    </>
  );
}

export default VideoContent;